module.exports = __webpack_public_path__ + "img/chart-stack-bar-vert.1b987ccd.svg";